export const LINK_PICKER_CONSTS = {
  invalidLinkMsg: 'Неверная ссылка',
  linkHasAlreadyBeenAddedMsg: 'Ссылка уже добавлена',
  maximumLinksMsg: 'Максимум ссылок',
  relatedLinkMsg: 'Ссылки по теме',
  samePublicationLinkErrorMsg: 'Нельзя ссылаться на эту же публикацию'
}
